<template>
  <div class="tooltip" v-if="isOpen">
    <div class="tooltip__icon">
      <vita-icon name="info"/>
    </div>
    <div class="tooltip__content">
      <h3 class="tooltip__title">{{title}}</h3>
      <p>{{text}}</p>
    </div>
    <div class="tooltip__close" @click="emit('closed')" data-qa="tooltip-icon-close">
      <vita-icon name="cross"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {ref, watch} from "vue";

interface Props {
  title: string,
  text: string,
  open: boolean
}

const props = defineProps<Props>()
const isOpen = ref<boolean>(props.open)
const emit = defineEmits(['closed'])

watch(props,(val: Props) => {
  isOpen.value = val.open
})
</script>

<script lang="ts">
export default {
  name: 'vita-tooltip'
}
</script>

<style scoped lang="scss">
@use '../../static/style/variables.scss' as *;

.tooltip {
  padding: 12px 24px;
  background: $white;
  display: flex;
  text-align: left;
  min-width: 555px;
  justify-content: space-between;
  white-space: nowrap;

  &__title {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 8px;
  }

  &__icon {
    margin-right: 8px;
  }

  &__close {
    margin-left: 8px;
    cursor: pointer;

    svg {
      fill:#888888;
    }
  }

  &__content {
    width: 100%;
  }
}
</style>
